module.exports = __webpack_public_path__ + "ath_game_web/img/9.2.aa4f78f0.png";